export default "__VITE_ASSET__C9lTkv3Z__"